import Visibility from "@material-symbols/svg-500/rounded/visibility.svg?react";
import { memo } from "react";

import { IconCreator } from "./_utils/icon-creator";

import type { SVGIconProps } from "./_utils/icon-creator";

const VisibilityIcon = (props: SVGIconProps) => {
	const Icon = () => IconCreator({ ...props, svgIcon: Visibility });
	return <Icon />;
};

export default memo(VisibilityIcon);
